import type { DailyBrief } from "../types";

export const fallbackBrief: DailyBrief = {
  generatedAt: "2026-05-26T13:00:00.000Z",
  runId: "seed-brief",
  status: "published",
  sourceHealth: [
    {
      name: "GitHub",
      status: "online",
      detail: "Search and repository metadata ready",
      detailZh: "仓库搜索和元数据抓取已就绪"
    },
    {
      name: "X",
      status: "planned",
      detail: "Signal enrichment after stable crawler setup",
      detailZh: "社交热度增强将在爬虫稳定后接入"
    },
    {
      name: "OpenClaw",
      status: "ready",
      detail: "Daily agent job can replace the local generator",
      detailZh: "每日 Agent 任务可接管本地生成器"
    }
  ],
  tools: [
    {
      rank: 1,
      name: "OpenHands",
      category: "Agent / Coding",
      categoryZh: "智能体 / 编程",
      summary: "An open-source software engineering agent focused on repository tasks, terminal actions, and iterative code changes.",
      summaryZh: "面向仓库任务、终端操作和迭代代码修改的开源软件工程智能体。",
      sourceUrl: "https://github.com/All-Hands-AI/OpenHands",
      githubStars: 58000,
      score: 92,
      verdict: "Worth trying",
      verdictZh: "值得试用",
      signals: ["Large contributor base", "Active issues", "Clear local runtime"],
      signalsZh: ["贡献者规模较大", "问题区活跃", "本地运行路径清晰"],
      analysis:
        "Useful when the work is repository-shaped: diagnose, edit, test, and explain changes. The main risk is operational setup complexity for non-technical users.",
      analysisZh:
        "适合处理仓库型工作：诊断、修改、测试并解释变更。主要风险是非技术用户的部署和运行成本较高。"
    },
    {
      rank: 2,
      name: "Dify",
      category: "Workflow / App Builder",
      categoryZh: "工作流 / 应用构建",
      summary: "A visual platform for building LLM apps, workflows, and agentic experiences with hosted or self-managed models.",
      summaryZh: "用于构建 LLM 应用、工作流和智能体体验的可视化平台，支持托管或自管模型。",
      sourceUrl: "https://github.com/langgenius/dify",
      githubStars: 90000,
      score: 89,
      verdict: "Track closely",
      verdictZh: "持续跟踪",
      signals: ["Strong docs", "Production-oriented", "Broad ecosystem"],
      signalsZh: ["文档完善", "偏生产场景", "生态较广"],
      analysis:
        "Dify is valuable for teams that want a controllable LLM app layer without writing every orchestration piece by hand. Watch for workflow sprawl as projects grow.",
      analysisZh:
        "Dify 适合想要可控 LLM 应用层、又不想手写所有编排逻辑的团队。项目变大后需要警惕工作流失控。"
    },
    {
      rank: 3,
      name: "Flowise",
      category: "Low-code AI",
      categoryZh: "低代码 AI",
      summary: "A drag-and-drop builder for LLM flows, chatbots, and retrieval pipelines.",
      summaryZh: "用于搭建 LLM 流程、聊天机器人和检索管线的拖拽式构建器。",
      sourceUrl: "https://github.com/FlowiseAI/Flowise",
      githubStars: 35000,
      score: 84,
      verdict: "Worth trying",
      verdictZh: "值得试用",
      signals: ["Fast prototyping", "Many integrations", "Community examples"],
      signalsZh: ["原型速度快", "集成较多", "社区案例丰富"],
      analysis:
        "Best as a prototyping surface for teams exploring RAG and workflow composition. Long-term maintainability depends on whether flows remain documented.",
      analysisZh:
        "适合作为 RAG 和工作流编排的原型工具。长期可维护性取决于流程是否持续被文档化。"
    }
  ],
  featured: {
    title: "Why AI Tool Discovery Needs an Agent, Not a Directory",
    titleZh: "为什么 AI 工具发现需要 Agent，而不是目录站",
    slug: "agent-maintained-ai-tool-intelligence",
    summary:
      "Directories collect links. ToolPulse AI scores signals, checks source evidence, and publishes only tools with a concrete use case.",
    summaryZh:
      "目录站只收集链接。ToolPulse AI 会评估信号、检查来源证据，只发布有明确使用场景的工具。",
    body:
      "The useful question is not whether a project is new. It is whether it can replace or improve a real workflow. ToolPulse AI treats each candidate as a research task: inspect the source, classify the target user, identify the workflow, score risk, and publish a clear verdict.",
    bodyZh:
      "真正有用的问题不是项目是否够新，而是它能否替代或改善真实工作流。ToolPulse AI 会把每个候选工具当成一次研究任务：查看来源、判断目标用户、识别工作流、评估风险，并给出明确结论。"
  },
  runLog: [
    "08:00 GitHub candidate scan scheduled",
    "08:03 Repository metadata normalized",
    "08:07 Editorial scoring complete",
    "08:10 Brief published after link checks"
  ],
  runLogZh: [
    "08:00 GitHub 候选扫描已启动",
    "08:03 仓库元数据已标准化",
    "08:07 编辑评分已完成",
    "08:10 链接检查后已发布简报"
  ]
};
